export const pokedexGen4 = {
  "pokedex387": "Chelast",
  "pokedex388": "Chelcarain",
  "pokedex389": "Chelterrar",
  "pokedex390": "Panflam",
  "pokedex391": "Panpyro",
  "pokedex392": "Panferno",
  "pokedex393": "Plinfa",
  "pokedex394": "Pliprin",
  "pokedex395": "Impoleon",
  "pokedex396": "Staralili",
  "pokedex397": "Staravia",
  "pokedex398": "Staraptor",
  "pokedex399": "Bidiza",
  "pokedex400": "Bidifas",
  "pokedex401": "Zirpurze",
  "pokedex402": "Zirpeise",
  "pokedex403": "Sheinux",
  "pokedex404": "Luxio",
  "pokedex405": "Luxtra",
  "pokedex406": "Knospi",
  "pokedex407": "Roserade",
  "pokedex408": "Koknodon",
  "pokedex409": "Rameidon",
  "pokedex410": "Schilterus",
  "pokedex411": "Bollterus",
  "pokedex412": "Burmy",
  "pokedex413": "Burmadame",
  "pokedex414": "Moterpel",
  "pokedex415": "Wadribie",
  "pokedex416": "Honweisel",
  "pokedex417": "Pachirisu",
  "pokedex418": "Bamelin",
  "pokedex419": "Bojelin",
  "pokedex420": "Kikugi",
  "pokedex421": "Kinoso",
  "pokedex422": "Schalellos",
  "pokedex423": "Gastrodon",
  "pokedex424": "Ambidiffel",
  "pokedex425": "Driftlon",
  "pokedex426": "Drifzepeli",
  "pokedex427": "Haspiror",
  "pokedex428": "Schlapor",
  "pokedex429": "Traunmagil",
  "pokedex430": "Kramshef",
  "pokedex431": "Charmian",
  "pokedex432": "Shnurgarst",
  "pokedex433": "Klingplim",
  "pokedex434": "Skunkapuh",
  "pokedex435": "Skuntank",
  "pokedex436": "Bronzel",
  "pokedex437": "Bronzong",
  "pokedex438": "Mobai",
  "pokedex439": "Pantimimi",
  "pokedex440": "Wonneira",
  "pokedex441": "Plaudagei",
  "pokedex442": "Kryppuk",
  "pokedex443": "Kaumalat",
  "pokedex444": "Knarksel",
  "pokedex445": "Knakrack",
  "pokedex446": "Mampfaxo",
  "pokedex447": "Riolu",
  "pokedex448": "Lucario",
  "pokedex449": "Hippopotas",
  "pokedex450": "Hippoterus",
  "pokedex451": "Pionskora",
  "pokedex452": "Piondragi",
  "pokedex453": "Glibunkel",
  "pokedex454": "Toxiquak",
  "pokedex455": "Venuflibis",
  "pokedex456": "Finneon",
  "pokedex457": "Lumineon",
  "pokedex458": "Mantirps",
  "pokedex459": "Shnebedeck",
  "pokedex460": "Rexblisar",
  "pokedex461": "Snibunna",
  "pokedex462": "Magnezone",
  "pokedex463": "Schlurplek",
  "pokedex464": "Rihornior",
  "pokedex465": "Tangoloss",
  "pokedex466": "Elevoltek",
  "pokedex467": "Magbrant",
  "pokedex468": "Togekiss",
  "pokedex469": "Yanmega",
  "pokedex470": "Folipurba",
  "pokedex471": "Glaziola",
  "pokedex472": "Skorgro",
  "pokedex473": "Mamutel",
  "pokedex474": "Porygon-Z",
  "pokedex475": "Galagladi",
  "pokedex476": "Voluminas",
  "pokedex477": "Zwirrfinst",
  "pokedex478": "Frosdedje",
  "pokedex479": "Rotom",
  "pokedex480": "Selfe",
  "pokedex481": "Vesprit",
  "pokedex482": "Tobutz",
  "pokedex483": "Dialga",
  "pokedex484": "Palkia",
  "pokedex485": "Heatran",
  "pokedex486": "Regigigas",
  "pokedex487": "Giratina",
  "pokedex488": "Cresselia",
  "pokedex489": "Phione",
  "pokedex490": "Manaphy",
  "pokedex491": "Darkrai",
  "pokedex492": "Shaymin",
  "pokedex493": "Arceus",
  "pokedex494": "Victini",
};